import moment from 'moment';

export class TaskTreeNode {
  id: string;
  text: string;
  expanded?: boolean;
  items?: TaskTreeNode[];

  constructor(public task: UserTaskModel) {
    this.id = task.taskID;
    this.text = task.description
    this.expanded = false;
    this.items = [];
  }
}

export class UserTaskModel {
  public finished: boolean = false;
  public due: string = "";

  constructor(
    public taskID: string,
    public description: string,
    public enumTaskType: string,  // TODO: replace this later
    due: Date
  ) {
    this.due = moment(due).fromNow();
  }
}
